<template>
    <v-sheet :color="`grey lighten-4`">
        <v-skeleton-loader :max-height="maxHeight" type="card"></v-skeleton-loader>
    </v-sheet>
</template>

<script>
    export default {
        name: "CardLoader",
        props: ['maxHeight']
    }
</script>

<style scoped>

</style>
